import { RecruitingMeetingPage } from './index'
import { ZoomHostPage, MeetingEndedPage } from './components/ZoomHost'
import { RouteFactory } from './../../shared/router/Route.factory'

// Path is configurable via .env so management can rename without code edits.
// REACT_APP_RECRUITING_MEETING_URL_PATH is inlined at build time (Create React
// App convention). Default falls back to 'recruiting-meeting' for safety.
const URL_PATH = (process.env.REACT_APP_RECRUITING_MEETING_URL_PATH || 'recruiting-meeting').replace(/^\/+/, '')

export default [
  RouteFactory.create(
    RecruitingMeetingPage,
    `/${URL_PATH}`,
    [], // no guards — public route
    { name: 'Career Opportunity | USA Benefits Group' }
  ),
  // Iframe-only host route for the Zoom Web SDK Client View. Rendered as a
  // bare shell (no DashboardLayout, no sidebar) inside the parent page's
  // left pane via <iframe>. Public route — auth is enforced at the JWT
  // signature level by the SDK.
  RouteFactory.create(ZoomHostPage, `/${URL_PATH}/zoom-host`, [], {
    name: 'Zoom Host',
  }),
  // Landing for ZoomMtg.init({leaveUrl}). On mount, posts state:'ended' to
  // the parent so the page can transition cleanly when the user clicks Leave
  // inside the Zoom chrome.
  RouteFactory.create(MeetingEndedPage, `/${URL_PATH}/meeting-ended`, [], {
    name: 'Meeting Ended',
  }),
]
